import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";
import BannerWrapper from "./shared/BannerWrapper";
import PlusBannerButton from "./shared/PlusBannerButton";

const i18nRoot = "circle_plus.banners.mobile_settings";

export const MobileSettingsBanner = () => {
  const { trackEvent } = useEventsTracker();

  const handleOnClick = () => {
    trackEvent("plus_banner.cta.clicked", {
      origin: "mobile.settings",
    });
  };

  return (
    <BannerWrapper>
      <div className="bg-plus-banner mobile-settings-custom-backround mb-10 rounded-lg bg-contain bg-right bg-no-repeat text-white dark:bg-white dark:text-slate-950">
        <div className="w-1/2 p-4 md:w-full md:px-10 md:py-8">
          <div className="text-base font-bold md:text-2xl">
            {t(`${i18nRoot}.title`)}{" "}
          </div>
          <Link
            to={settingsNavPathV3.plans.brandedApps}
            onClick={handleOnClick}
          >
            <PlusBannerButton>{t(`${i18nRoot}.button`)}</PlusBannerButton>
          </Link>
        </div>
      </div>
    </BannerWrapper>
  );
};

export default MobileSettingsBanner;
